module.exports = __webpack_public_path__ + "img/desktop_honey.7b2278b7.png";